import { render } from "./SMaintenance.vue?vue&type=template&id=5bcc9a73&scoped=true&ts=true"
import script from "./SMaintenance.vue?vue&type=script&lang=ts"
export * from "./SMaintenance.vue?vue&type=script&lang=ts"

import "./SMaintenance.vue?vue&type=style&index=0&id=5bcc9a73&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcc9a73"]])

export default __exports__